import React, { useEffect } from "react";
import { useAuth } from "../../../utils/AuthContext";
import Dashboard from "../Dashboard";
import SummaryComponent from "../../../features/adminDashboard/adminDashboardTab/Summary";
import UsersComponent from "../../../features/adminDashboard/adminDashboardTab/Users";
import OrdersComponent from "../../../features/adminDashboard/adminDashboardTab/Orders";
import ProductsComponent from "../../../features/adminDashboard/adminDashboardTab/Products";
import CategoriesComponent from "../../../features/adminDashboard/adminDashboardTab/Categories";
import OffersComponent from "../../../features/adminDashboard/adminDashboardTab/Offers";

const AdminDashboard = () => {
  const { user } = useAuth();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const adminInfo = () => {
    return (
      <div className="space-y-6">
        {/* Quick Stats */}
        <SummaryComponent />
        <UsersComponent />
        <OrdersComponent />
        <ProductsComponent />
        <CategoriesComponent />
        <OffersComponent />

        {/* Quick Actions */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="p-6 border-b border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900">
                Recent Activity
              </h3>
            </div>
            <div className="p-6">
              <div className="text-center text-gray-500 py-8">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={48}
                  height={48}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mx-auto mb-4 text-gray-300"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12,6 12,12 16,14"></polyline>
                </svg>
                <p className="text-lg font-medium">No recent activity</p>
                <p className="text-sm">
                  Your admin activities will appear here
                </p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    );
  };

  return (
    <Dashboard
      title="Admin Dashboard"
      description="Manage your store and monitor performance"
    >
      {adminInfo()}
    </Dashboard>
  );
};

export default AdminDashboard;
